.rootWithFallback {
  position: relative;
  min-height: var(--haus-variantselector__skeleton__min-height, 0);
}

.optionGroup {
  display: flex;
  flex-direction: column;
  gap: var(
    --haus-variantselector__optiongroup__resolved-gap,
    var(--haus-variantselector__optiongroup__gap, var(--haus-spacing-sm, 10px))
  );
}

.optionGroupsContainer {
  display: var(--haus-variantselector__optiongroupscontainer__display, flex);
  flex-direction: var(--haus-variantselector__optiongroupscontainer__flex-direction, column);
  gap: var(
    --haus-variantselector__optiongroupscontainer__resolved-gap,
    var(--haus-variantselector__optiongroupscontainer__gap, 16px)
  );
}

.optionGroupLabel {
  font-weight: var(
    --haus-variantselector__optiongrouplabel__font-weight,
    var(--haus-typography-lg-font-weight, 700)
  );
  font-size: var(
    --haus-variantselector__optiongrouplabel__font-size,
    var(--haus-typography-lg-font-size, 16px)
  );
  color: var(--haus-variantselector__optiongrouplabel__color, var(--haus-color-body, #323231));
  font-family: var(
    --haus-variantselector__optiongrouplabel__font-family,
    var(--haus-typography-body-font-family, Inter, sans-serif)
  );
  text-transform: var(--haus-variantselector__optiongrouplabel__text-transform, capitalize);
  line-height: var(--haus-variantselector__optiongrouplabel__line-height, 1);
  min-height: var(
    --haus-variantselector__optiongrouplabel__min-height,
    calc(
      var(--haus-variantselector__optiongrouplabel__line-height, 1) *
        var(
          --haus-variantselector__optiongrouplabel__font-size,
          var(--haus-typography-lg-font-size, 16px)
        )
    )
  );
}

.optionsContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(
    --haus-variantselector__optionscontainer__resolved-gap,
    var(--haus-variantselector__optionscontainer__gap, var(--haus-spacing-xs, 8px))
  );
}

.optionButton {
  text-transform: capitalize;
}

button.optionButton {
  color: var(--haus-variantselector__optionbutton__color, var(--haus-color-body, #323231));
  border-radius: var(--haus-variantselector__optionbutton__border-radius, 120px);
  border-width: var(--haus-variantselector__optionbutton__border-width, 1px);
  border-style: var(--haus-variantselector__optionbutton__border-style, solid);
  border-color: var(--haus-variantselector__optionbutton__border-color, #0000001a);
  font-family: var(
    --haus-variantselector__optionbutton__font-family,
    var(--haus-typography-body-font-family, Inter, sans-serif)
  );
  font-size: var(
    --haus-variantselector__optionbutton__font-size,
    var(--haus-typography-body-font-size, 16px)
  );
  font-weight: var(
    --haus-variantselector__optionbutton__font-weight,
    var(--haus-typography-body-font-weight, 400)
  );
  line-height: var(--haus-variantselector__optionbutton__line-height, 1.5);
  min-height: var(
    --haus-variantselector__optionbutton__min-height,
    calc(
      var(--haus-variantselector__optionbutton__line-height, 1.5) *
        var(--haus-variantselector__optionbutton__font-size, 16px) +
        (2 * var(--haus-variantselector__optionbutton__padding-block, 6px)) +
        (2 * var(--haus-variantselector__optionbutton__border-width, 1px))
    )
  );
  background-color: transparent;
  padding-block: var(--haus-variantselector__optionbutton__padding-block, 6px);
  padding-inline: var(--haus-variantselector__optionbutton__padding-inline, 16px);
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &.optionButtonSelected {
    border-color: var(
      --haus-variantselector__optionbutton__selected__border-color,
      var(--haus-color-primary, #ec622b)
    );
  }
}
